import React, { useState, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import '../styles.css';
import { DefaultLayout } from '../../../layouts/DefaultLayout';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { DocumentRenderer } from '../../../components/DocumentRenderer';
import config from '../../../config';
import { useAuth } from 'react-oidc-context';

/**
 * Component for updating a question
 */
function UpdateQuestion() {
  const { quizBankId, questionId } = useParams();
  const auth = useAuth();
  const navigate = useNavigate();
  let count = 0;
  // TODO: Fix this part. We don't have an endpoint to retrieve data of a single question,
  // so this component relies on data coming from parent /questions component, but it's
  // currently broken. Either fix the current logic or create a new endpoint for retrieving
  // data of a single question, and take advantage of that endpoint in this component.
  const state = useLocation().state.questions;
  console.log(state);
  const checkedValue = state.options.filter((item: any) => item.is_correct);
  const [question, setQuestion] = useState(state.content);
  const [answers, setAnswers]: any = useState(state.options);
  answers.map((item: any) => (item.is_correct ? count++ : count));
  let [checkedValues, setCheckedValues]: any = useState(
    checkedValue.map((item: any) => item.text),
  );
  const [questionType, setQuestionType] = useState(
    count >= 2 ? 'multiple' : 'single',
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [answerText, setAnswerText] = useState(
    answers.map((item: any) => item.text),
  );
  const [isVisible, setIsVisible] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const ref: any = useRef(null);

  /**
   *change question
   */
  const handleChange = (e: any) => {
    setQuestion(e.target.value);
  };

  /**
   *change type of question
   */
  const handleTypeChange = () => {
    if (questionType === 'multiple') {
      setQuestionType('single');
    } else {
      setQuestionType('multiple');
    }
    let max = 0;
    if (checkedValues.length > 1) {
      for (let i = 0; i < checkedValues.length; i++) {
        const index = answerText.indexOf(checkedValues[i]);
        if (index >= max) {
          max = index;
        }
      }
      checkedValues = checkedValues.filter((item: any) => item === answerText[max]);
      setCheckedValues(checkedValues);
    }
  };
  /**
   *add answer
   */
  const handleAddAnswer = () => {
    setAnswers([...answers, { answer: '' }]);
    if (answers.length === 0) {
      setIsVisible(false);
    }
  };
  const handleDeleteAnswer = () => {
    setAnswers(answers.slice(0, -1));
    console.log(answers);
    if (answers.length === 1) {
      setIsVisible(true);
    }
  };

  async function updateQuestion(): Promise<boolean> {
    try {
      const response = await fetch(
        `${config.QUIZ_MANAGEMENT_API_URL}/quiz-banks/${quizBankId}/questions/${questionId}`,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Bearer ${auth.user?.access_token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            content: `${question}`,
            options: answers.map((option: any) => ({
              text: option.text,
              is_correct: checkedValues.includes(option.text),
            })),
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
      }

      return true;
    } catch (err) {
      return false;
    }
  }

  /**
   *handleSubmit
   */
  const handleSubmit = async (e: any, index: any) => {
    e.preventDefault();

    setIsSubmitted(false);

    const { name, value }: any = ref.current;
    const list = [...answers];
    list[index][name] = value;
    setAnswers(list);

    const isUpdated = await updateQuestion();

    if (!isUpdated) {
      // TODO: Add a visual error
      return;
    }

    setIsSubmitted(true);

    setTimeout(() => setIsSubmitted(false), 2000);
  };

  /**
   * handleCancel
   */
  const handleCancel = () => {
    navigate(`/quizbank/${quizBankId}/questions`);
  };

  /**
   *change answer
   */
  const handleAnswerChange = (e: any, index: any) => {
    const { name, value } = e.target;
    const list = [...answers];
    console.log(list);
    list[index][name] = value;
    setAnswers(list);
  };

  /**
   *handle correct answer
   */
  const handleCorrectAnswerChange = (e: any) => {
    const { checked, value } = e.target;
    if (e.target.type == 'checkbox') {
      if (checked) {
        checkedValues.push(value);
        console.log(checkedValues);
        // setCheckedValues([...checkedValues, value]);
      } else {
        setCheckedValues(checkedValues.filter((e: any) => e !== value));
      }
    } else if (e.target.type == 'radio') {
      if (checked) {
        setCheckedValues([value]);
      } else {
        setCheckedValues(checkedValues.filter((e: any) => e !== value));
      }
    }
  };

  return (
    <>
      <DefaultLayout>
        <div className="mx-3">
          <h3 className="mb-3">Sualın yaradılması</h3>
          <div className="d-flex justify-content-between align-items-center">
            <form className="question-form">
              <div className="quiz-form">
                <label>Sual növü:</label>
                <select
                  value={questionType}
                  onChange={handleTypeChange}
                  className="form-select"
                  name="questionType"
                >
                  <option value="single">Tək variantlı</option>
                  <option value="multiple">Çox variantlı</option>
                </select>
              </div>
              <br />
              <div className="d-flex justify-content-between">
                <div>
                  <label>Sual:</label>
                  <br />
                  <textarea
                    value={question}
                    name="question"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    className="form-control"
                    rows={10}
                    cols={55}
                  />
                </div>
                <div className="markdown mt-4 form-control">
                  <DocumentRenderer src={question ?? ''} />
                </div>
              </div>
              <br />
              {isVisible && (
                <button
                  className="btn-add-answer"
                  type="button"
                  onClick={handleAddAnswer}
                >
                  Cavab əlavə et
                </button>
              )}
              {answers.map((answer: any, index: any) => (
                <div key={index} id={index}>
                  <div className="d-flex justify-content-between">
                    <div className="mt-4">
                      <label>Cavab {index + 1}</label>
                      <br />
                      <textarea
                        className="form-control"
                        ref={ref}
                        value={answer.text}
                        name="text"
                        required
                        onChange={(e) => handleAnswerChange(e, index)}
                        rows={6}
                        cols={55}
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-end align-items-end">
                      <div
                        className="correct-answer d-flex justify-content-center align-items-center mb-2"
                        id={index}
                      >
                        <input
                          ref={ref}
                          type={questionType === 'multiple' ? 'checkbox' : 'radio'}
                          name="is_correct"
                          value={answer.text}
                          defaultChecked={answer.is_correct ? true : false}
                          onClick={(e) => handleCorrectAnswerChange(e)}
                        />
                        <label>Düzgün cavab</label>
                        <button
                          className="btn btn-danger"
                          type="button"
                          onClick={handleDeleteAnswer}
                        >
                          <span>Cavabı sil</span>
                        </button>
                      </div>
                      <div className="markdown md-answer form-control">
                        <DocumentRenderer src={answer.text ?? ''} />
                      </div>
                    </div>
                  </div>

                  <br />
                  {answers.length - 1 === index && (
                    <>
                      {' '}
                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleAddAnswer}
                      >
                        <span>Yeni Cavab</span>
                      </button>
                    </>
                  )}
                </div>
              ))}
              <div className="quiz-buttons d-flex question-btn">
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    handleSubmit(e, ref.current?.parentElement.getAttribute('id'));
                  }}
                >
                  Yadda saxla
                </button>
                <button className="btn btn-secondary" onClick={handleCancel}>
                  İmtina
                </button>
              </div>
            </form>
            <br />
          </div>
          {isSubmitted && (
            <Stack sx={{ width: '100%', marginTop: '10px' }}>
              <Alert>Sual redaktə olundu!</Alert>
            </Stack>
          )}
        </div>
      </DefaultLayout>
    </>
  );
}
export default UpdateQuestion;
